import { Component, inject, Input } from '@angular/core';
import { Uuid } from '../../../../graphql';
import { LeadsService } from '../../../core/services/leads.service';
import { MessagingService } from '../../../core/services/messaging.service';
import { FeatureService } from '../../../core/services/permission';

interface Customer {
    ID_Customer: Uuid;
}

@Component({
    selector: 'app-client-messages',
    templateUrl: './clients-messages.component.html',
    standalone: false,
})
export class ClientMessagesComponent {
    @Input() customer?: Customer;
    hasAnyMessages: boolean = false;
    canViewSms = inject(FeatureService).isAvailable('sms-features');

    constructor(
        private leadsService: LeadsService,
        private messagingService: MessagingService
    ) {}

    ngOnInit(): void {
        if (this.customer) {
            this.leadsService.getLeadDetailsByCustomerId(this.customer.ID_Customer).subscribe((result) => {
                if (result.data.leadDetailsByCustomerId.length > 0) {
                    let leadIds: Uuid[] = [];
                    result.data.leadDetailsByCustomerId.map((lead) => {
                        leadIds.push(lead.iD_Lead);
                    });

                    if (leadIds.length > 0) {
                        this.messagingService.getConversationsByLeadIds(0, 1, leadIds, '').subscribe((res) => {
                            this.hasAnyMessages = res.data.conversationsByLeadsId.length > 0;
                        });
                    }
                }
            });
        }
    }
}
